export default __webpack_public_path__ + "static/media/lc-logo.ce603127.png";